import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import COLORS from '~/constants/colors';
import { FONT_WEIGHTS } from '~/constants/typography';
import { stopEventEffects } from '~/utils';

import { RendererProps } from '../../models';
import { getPx } from '../../helpers';

function Exit({ entity }: RendererProps): ReactElement {
  const pos = entity.getPos();
  const navigate = useNavigate();

  // Handlers
  const handleClick = (event) => {
    stopEventEffects(event);
    navigate(entity.redirect, {
      state: {
        ...entity.gameEngineRef.current?.state.entities.state,
        quit: true,
      },
    });
  };

  // Styling
  const exitB = entity.dims.b ?? 0;
  const exitM = entity.dims.m ?? 0;
  const exitStyle = {
    position: 'absolute' as const,
    width: getPx(entity.dims.w),
    height: getPx(entity.dims.h),
    lineHeight: getPx(entity.dims.h),
    top: getPx(pos.y + exitM),
    left: getPx(pos.x - entity.dims.w - 1.3 * exitM),
    backgroundColor: COLORS.dreamlessSleep,
    borderRadius: getPx(exitB),
    borderStyle: 'solid',
    borderWidth: getPx(exitB / 20),
    borderColor: COLORS.mineShaft,
    cursor: 'pointer',
    zIndex: 3,
  };
  const xStyle = {
    display: 'inline-block',
    position: 'relative' as const,
    marginTop: getPx(-entity.dims.h / 5),
    lineHeight: 'normal',
    verticalAlign: 'middle',
    color: COLORS.white50,
    fontSize: getPx(entity.dims.w / 1.2),
    fontWeight: FONT_WEIGHTS.thin,
  };

  return (
    <div
      role="none"
      style={exitStyle}
      onMouseUp={handleClick}
      onTouchEnd={handleClick}
    >
      <div style={xStyle}>×</div>
    </div>
  );
}

export default Exit;
